import "./ScrollToTop.css";

import { useState, useEffect } from "react";

export default function ScrollToTop() {
	const [showScrollButton, setShowScrollButton] = useState(false);

	useEffect(() => {
		window.addEventListener("scroll", () => {
			if (window.scrollY > 400) {
				setShowScrollButton(true);
			} else {
				setShowScrollButton(false);
			}
		});
	}, []);

	const scrollToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	};

	return (
		<div className={`scrollToTop ${showScrollButton ? "open" : ""}`} onClick={scrollToTop}>
            <div className="arrow-up icon"></div>
		</div>
	);
}